import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const JobHistory: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
        Job History
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Job execution history and logs will be displayed here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default JobHistory;

